import React, { useMemo } from 'react';

import { SelectableTags } from '../../../../components/SelectableTags';
import {
  REPORT_GENERATOR_CATEGORY_FILTER_ALL,
  ReportGeneratorCategory,
} from '../../../../store/reportGenerator/categories';

interface ReportCategoryTagsProps {
  categories: ReportGeneratorCategory[];
  selectedCategoryFilterId: string;
  onSelectCategoryFilter: (categoryFilterId: string) => void;
}

export const ReportCategoryTags: React.FC<ReportCategoryTagsProps> = ({
  categories,
  selectedCategoryFilterId,
  onSelectCategoryFilter,
}) => {
  const options = useMemo(
    () => [
      { label: 'Todos', value: REPORT_GENERATOR_CATEGORY_FILTER_ALL },
      ...categories.map((category) => ({ label: category.label, value: category.id })),
    ],
    [categories]
  );

  if (!categories.length) {
    return null;
  }

  return (
    <SelectableTags
      options={options}
      selectedValues={[selectedCategoryFilterId]}
      onChange={(value) => onSelectCategoryFilter(value)}
      testIDPrefix="report-generator-category-tag"
    />
  );
};
